// src/locales/translations.ts
const translations = {
    en: {
      //navbar
      userManagementApp: 'Platform Management App',
      home: 'Home',
      manageUsers: 'Manage Users',
      setupUsers: 'Setup Users',
      serverAccounts: 'Servers Acct Admin',
      licenseAdministration: 'License Administration',
      systemDashboard: 'System Dashboard',
      settings: 'Settings',
      uploadExcel: 'Upload Excel',

      // Page titles
      manageUsersPageTitle: 'Manage Users and their Licenses',
      setupUsersPageTitle: 'Setup Users',
      serverAccountsPageTitle: 'Manage server accounts',
      licenseAdministrationPageTitle: 'License Administration',
      systemDashboardPageTitle: 'System Dashboard',

      // Dashboard button labels
      manageUsersBtn: 'Manage Users',
      setupUsersBtn: 'Setup Users',
      licenseAdminBtn: 'License Admin',
      serverAccountsBtn: 'Server Accounts',
      refreshDataBtn: 'Refresh Data',
      exportDataBtn: 'Export Data',
      viewReportsBtn: 'View Reports',

      // License Management Page
      syncOptions: 'Sync Options',
      rereadServer: 'Reread Server',
      disableSelected: 'Disable Selected',
      enableSelected: 'Enable Selected',
      requestExtension: 'Request Extension',
      removeSelected: 'Remove Selected',
      updateExpiryStatus: 'Update Expiry Status',
      configureColumns: 'Configure Columns',
      optionFileLabel: 'Option File:',
      requestLicenseExtension: 'Request License Extension',
      configureVisibleColumns: 'Configure Visible Columns',
      manageLicensesServerOps: 'Manage licenses & server operations',

      // User Management Components
      disableSelectedUsers: 'Disable Selected',
      enableSelectedUsers: 'Enable Selected',
      requestExtensionUsers: 'Request Extension',
      removeSelectedUsers: 'Remove Selected',
      configureColumnsUsers: 'Configure Columns',
      userLicenseDashboard: 'User License Dashboard',
      userIdentifiers: 'User Identifiers',
      associatedServers: 'Associated Servers',
      extensionRequestDetails: 'Extension Request Details',
      newEndDate: 'New End Date',
      selectNewEndDate: 'Select new end date',
      selectedExtensionDate: 'Selected',
      remarksOptional: 'Remarks (Optional)',
      reasonForExtension: 'Reason for extension request...',
      selectedLicenses: 'Selected Licenses',
      extensionApprovalRequired: 'Extension requests require approval from IT administrators before taking effect.',

      // Breadcrumb labels
      breadcrumbAdmin: 'Admin',
      breadcrumbInfraUser: 'Infra User',
      breadcrumbInfraUsers: 'Infra Users',
      breadcrumbLicenses: 'Licenses',
      breadcrumbLicWorkflow: 'Lic Workflow',
      breadcrumbSystemDashboard: 'System Dashboard',

      // Extension Approval Page
      extensionApprovals: 'Extension Approvals',
      manageExtensionRequests: 'Manage license extension requests',
      pendingRequests: 'Pending Requests',
      approvalHistory: 'Approval History',
      extensionWorkflow: 'Lic Workflow',
      noProcessedRequestsFound: 'No processed requests found',
      approveSelected: 'Approve',
      rejectSelected: 'Reject',
      selectRequestsToBulkProcess: 'Select requests to bulk process',
      confirmApproval: 'Confirm Approval',
      confirmRejection: 'Confirm Rejection',
      approveAllSelected: 'Approve All',
      rejectAllSelected: 'Reject All',
      selectedRequestsToApprove: 'Requests to approve',
      selectedRequestsToReject: 'Requests to reject',
      selectedRequestsDetails: 'Selected Requests Details',
      bulkApproval: 'Bulk Approval',
      bulkRejection: 'Bulk Rejection',

      // License Management Page
      licenseServerLabel: 'Server:',
      toolsFilter: 'Tools',
      statusFilter: 'Status',
      dateFilter: 'Date',
      clearFilters: 'Clear',
      licensesDisabled: 'licenses disabled successfully',
      licensesEnabled: 'licenses enabled successfully',
      extensionRequested: 'Extension request submitted',
      jobExecuted: 'License expiry status update job completed',
      selectExtensionDate: 'Select extension date',
      extensionRemarks: 'Remarks (Optional)',

      // User Table Page
      allUsers: 'All Users',
      activeOnly: 'Active Only',
      expiredOnly: 'Expired Only',
      expiringSoon: 'Expiring Soon',
      serverInfo: 'Server Info',
      userId: 'User Id',
      email: 'Email',
      enabled: 'Enabled',
      primaryGroup: 'Primary Group',
      vncPorts: 'VNC Ports',
      accountExpiry: 'Account Expiry',
      refreshData: 'Refresh Data',
      exportData: 'Export',
      usersDisabled: 'Users disabled successfully',
      usersEnabled: 'Users enabled successfully',
      accountExpiryExtended: 'Account expiry extension completed',

      // Navbar
      profile: 'Profile',
      logout: 'Logout',

      // General UI
      searchBy: 'Search by',
      selected: 'selected',
      noRowsSelected: 'No rows selected!',
      operationCompleted: 'operation completed',
      operationFailed: 'operation failed',
      statusLabel: 'Status',

      // userTable page (legacy - may be updated)
      userManagement: 'User Management',
      globalFilterPlaceholder: 'Global Filter...',
      disableLogin: 'Disable Login',
      enableLogin: 'Enable Login',
      extendLogin: 'Extend Login',
      restartVNC: 'Restart VNC',
      refreshInfraUsers: 'Refresh InfraUsers',
      filterBy: 'Filter by',
      yes: 'Yes',
      no: 'No',
      nA: 'N/A',
      empty: "",

        // User Generation Page translations (updated)
    userGenerationPageTitle: 'Setup Users on Infra Servers',
    pleaseSelectFile: 'Please select a file.',
    reuploadFile: 'Reupload File',
    generateUsers: 'Generate Users',
    uploadAnotherFile: 'Upload Another File',

    reviewingByUser: 'Reviewing by admin',
    successfullyUploaded: 'Successfully uploaded',
    genOprnWIP: 'InfraUser Generation Operation in progress... Please wait.',
    genOprnCompleted: 'InfraUser Generation Operation Complete. Check results.',

    // Test localization keys for audit and transaction logs
    auditLogs: 'Audit Logs',
    transactionLogs: 'Transaction Logs',
    auditPageTitle: 'Transaction Audit Logs',
    auditTrail: 'Audit Trail',
    filterButton: 'Apply Filters',
    exportCsvButton: 'Export CSV',
    transactionTypeCol: 'Transaction Type',
    transactionStatusCol: 'Status',
    requestingUserCol: 'Requesting User',
    timestampCol: 'Timestamp',
    licenseServerCol: 'License Server',
    serverInfoCol: 'Server Info',
    remarksCol: 'Remarks',
    responseDataCol: 'Response Data',

    },
    // Add other languages here, if necessary

  };
  
  export default translations;
